<div class="tilebody">
<div class="main1">
  <div class="hex1">
    <img src="../../assets/img/image1.png" class="clip" />
  </div>
  <div class="hex2">
    <img src="../../assets/img/image2.png" class="clip" />
  </div>
  <div class="hex3">
    <img src="../../assets/img/image3.jpg" class="clip" />
  </div>
  <div class="hex4">
    <img src="../../assets/img/image4.png" class="clip" />
  </div>
  <div class="hex5">
    <img src="../../assets/img/image5.jpg" class="clip" />
  </div>
  <div class="hex6">
    <img src="../../assets/img/image6.jpg" class="clip" />
  </div>
  <div class="hex7">
    <img src="../../assets/img/image7.jpg" class="clip" />
  </div>
  <div class="hex8">
    <img src="../../assets/img/image8.jpg" class="clip" />
  </div>
</div>
</div>
